import { useMemo } from 'react';
import { ApolloClient, InMemoryCache } from '@apollo/client';

const cache = new InMemoryCache();

const createApolloClient = (): ApolloClient<unknown> =>
  new ApolloClient({
    cache,
    uri: process.env.LOMA_URL,
  });

const useApolloClient = (): ApolloClient<unknown> => {
  const store = useMemo(() => createApolloClient(), []);
  return store;
};

export default useApolloClient;
